
import { numberWithCommas } from "../../Report_common_function";

export const columns = [
    "Item Name",
    "Quantity",
    "UOM",
    "Net Amount",
    "GST Rate",
    "CGST Amount",
    "SGST Amount",
    "IGST Amount",
    "Gross Total",
    "AVG Rate",
];

export const GST_Persentage_Table = [
    "GST Percentage",
    "Total Quantity",
    "Value",
    "CGST Amount",
    "SGST Amount",
    "IGST Amount",
    "Total",
];

export const Unit_Wise_Table = [
    "Unit",
    "Total Quantity",
    "Value",
    "CGST Amount",
    "SGST Amount",
    "IGST Amount",
    "Total",
];


export const PageHedercolumns = [
    "",
]


export const Rows = (data) => {
    const returnArr = [];
    let TotalBasicAmount = 0;
    let TotalQuantity = 0;
    let TotalCGST = 0;
    let TotalSGST = 0;
    let TotalIGST = 0;
    let TotalGrandTotal = 0;




    data.forEach((element, key) => {

        const tableitemRow = [
            `${element.ItemName}`,
            isNaN(element.Quantity) ? "0" : `${element.Quantity}`,
            `${element.UnitName}`,
            isNaN(element.BasicAmount) ? "0" : `${element.BasicAmount}`,
            isNaN(element.GSTRate) ? "0" : `${element.GSTRate}`,
            isNaN(element.CGST) ? "0" : `${element.CGST}`,
            isNaN(element.SGST) ? "0" : `${element.SGST}`,
            isNaN(element.IGST) ? "0" : `${element.IGST}`,
            isNaN(element.GrandTotal) ? "0" : `${element.GrandTotal}`,
            isNaN(element.AvgRate) ? "0" : `${element.AvgRate}`,
        ];


        TotalBasicAmount = Number(TotalBasicAmount) + Number(element.BasicAmount)
        TotalQuantity = Number(TotalQuantity) + Number(element.Quantity)
        TotalCGST = Number(TotalCGST) + Number(element.CGST)
        TotalSGST = Number(TotalSGST) + Number(element.SGST)
        TotalIGST = Number(TotalIGST) + Number(element.IGST)
        TotalGrandTotal = Number(TotalGrandTotal) + Number(element.GrandTotal)




        function totalrow() {
            const safeFormat = (value) =>
                isNaN(value) ? "0.00" : Number(value).toFixed(2);

            return [
                "Total",
                numberWithCommas(safeFormat(TotalQuantity)),
                "",
                numberWithCommas(safeFormat(TotalBasicAmount)),
                "",
                numberWithCommas(safeFormat(TotalCGST)),
                numberWithCommas(safeFormat(TotalSGST)),
                numberWithCommas(safeFormat(TotalIGST)),
                numberWithCommas(safeFormat(TotalGrandTotal)),
                "",
            ];
        };
        returnArr.push(tableitemRow);
        if (key === data.length - 1) {
            returnArr.push(totalrow());
        }
    })
    return returnArr;
}

export const GST_Rows = (data) => {
    const returnArr = [];
    
    const safeFormat = val => isNaN(val) ? "0.00" : Number(val).toFixed(2);
    

    // Initialize totals
    let totalQty = 0,
        totalBasic = 0,
        totalCGST = 0,
        totalSGST = 0,
        totalIGST = 0,
        totalGrand = 0;

    // Group data by GST percentage
    const gstWiseTotals = {};

    data.forEach(item => {
        const gst = Number(item.GSTRate || 0);

        if (!gstWiseTotals[gst]) {
            gstWiseTotals[gst] = {
                Quantity: 0,
                BasicAmount: 0,
                CGST: 0,
                SGST: 0,
                IGST: 0,
                GrandTotal: 0
            };
        }

        gstWiseTotals[gst].Quantity += Number(item.Quantity) || 0;
        gstWiseTotals[gst].BasicAmount += Number(item.BasicAmount) || 0;
        gstWiseTotals[gst].CGST += Number(item.CGST) || 0;
        gstWiseTotals[gst].SGST += Number(item.SGST) || 0;
        gstWiseTotals[gst].IGST += Number(item.IGST) || 0;
        gstWiseTotals[gst].GrandTotal += Number(item.GrandTotal) || 0;

        // Update grand totals
        totalQty += Number(item.Quantity) || 0;
        totalBasic += Number(item.BasicAmount) || 0;
        totalCGST += Number(item.CGST) || 0;
        totalSGST += Number(item.SGST) || 0;
        totalIGST += Number(item.IGST) || 0;
        totalGrand += Number(item.GrandTotal) || 0;
    });

    // Add GST-wise rows
    Object.entries(gstWiseTotals).forEach(([gstPercent, values]) => {
        returnArr.push([
            `GST ${gstPercent}%`,
            numberWithCommas(safeFormat(values.Quantity)),
            numberWithCommas(safeFormat(values.BasicAmount)),
            numberWithCommas(safeFormat(values.CGST)),
            numberWithCommas(safeFormat(values.SGST)),
            numberWithCommas(safeFormat(values.IGST)),
            numberWithCommas(safeFormat(values.GrandTotal)),
        ]);
    });

    // Add final Grand Total row
    returnArr.push([
        "Total",
        numberWithCommas(safeFormat(totalQty)),
        numberWithCommas(safeFormat(totalBasic)),
        numberWithCommas(safeFormat(totalCGST)),
        numberWithCommas(safeFormat(totalSGST)),
        numberWithCommas(safeFormat(totalIGST)),
        numberWithCommas(safeFormat(totalGrand)),
    ]);

    return returnArr;
};






export const Unit_Rows = (data) => {

    const returnArr = [];
    const safeFormat = val => isNaN(val) ? "0.00" : Number(val).toFixed(2);

    let totalQty = 0,
        totalBasic = 0,
        totalCGST = 0,
        totalSGST = 0,
        totalIGST = 0,
        totalGrand = 0;

    const unitWiseTotals = {};

    data.forEach(item => {

        const unit = item.UnitName || "NA";

        if (!unitWiseTotals[unit]) {
            unitWiseTotals[unit] = {
                Quantity: 0,
                BasicAmount: 0,
                CGST: 0,
                SGST: 0,
                IGST: 0,
                GrandTotal: 0
            };
        }

        unitWiseTotals[unit].Quantity += Number(item.Quantity) || 0;
        unitWiseTotals[unit].BasicAmount += Number(item.BasicAmount) || 0;
        unitWiseTotals[unit].CGST += Number(item.CGST) || 0;
        unitWiseTotals[unit].SGST += Number(item.SGST) || 0;
        unitWiseTotals[unit].IGST += Number(item.IGST) || 0;
        unitWiseTotals[unit].GrandTotal += Number(item.GrandTotal) || 0;

        totalQty += Number(item.Quantity) || 0;
        totalBasic += Number(item.BasicAmount) || 0;
        totalCGST += Number(item.CGST) || 0;
        totalSGST += Number(item.SGST) || 0;
        totalIGST += Number(item.IGST) || 0;
        totalGrand += Number(item.GrandTotal) || 0;
    });

    // ---- Unit rows
    Object.entries(unitWiseTotals).forEach(([unit, values]) => {
        returnArr.push([
            unit,
            numberWithCommas(safeFormat(values.Quantity)),
            numberWithCommas(safeFormat(values.BasicAmount)),
            numberWithCommas(safeFormat(values.CGST)),
            numberWithCommas(safeFormat(values.SGST)),
            numberWithCommas(safeFormat(values.IGST)),
            numberWithCommas(safeFormat(values.GrandTotal)),
        ]);
    });

    // ---- Final total row
    returnArr.push([
        "Total",
        numberWithCommas(safeFormat(totalQty)),
        numberWithCommas(safeFormat(totalBasic)),
        numberWithCommas(safeFormat(totalCGST)),
        numberWithCommas(safeFormat(totalSGST)),
        numberWithCommas(safeFormat(totalIGST)),
        numberWithCommas(safeFormat(totalGrand)),
    ]);

    return returnArr;
};


export const ReportHederRows = (data) => {

    const Division = data.SelectDivision.map((item, index) => `${index + 1}) ${item.label}`).join(", ")


    var reportArray = [
        [`                   ${Division}`],
        [`                   ${data.Date}`]
    ]


    return reportArray;
}

